module.exports = __webpack_public_path__ + "img/part3-watermark.4858c980.png";